<template>
  <div class="enterprise">
    <ContentView>
      <template slot="contentBox">
        <div class="detail-form-box" style="width:50%">
        <el-form class="notice-form" :model="form" label-position="top" :disabled="optType!='edit'?true:false">
           <el-form-item label="类型" >
                <el-select style="width:100%" v-model="form.type" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题" >
                <el-input v-model="form.title" autocomplete="off" ></el-input>
            </el-form-item>
           
            <el-form-item label="版本号" >
               <el-input  type="text" :rows="6" v-model="form.systemVersion" autocomplete="off"></el-input>
            </el-form-item>
             <el-form-item label="链接" >
                <el-input  type="text" :rows="6" v-model="form.wxUrl" autocomplete="off"></el-input>
            </el-form-item>
            <div style="width:100%; height:340px" id="summernote" v-model="content"></div>
            <!-- <el-form-item label="发布时间" >
                <el-date-picker
                v-model="form.pushTime"
                type="datetime"
                placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item> -->
        </el-form>
        </div>
      </template>
      <template slot="pagnation" v-if="optType=='edit'" >
            <div >
                <el-button @click="onClose">取 消</el-button>
                <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
            </div>
        </template>
    </ContentView>

  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  name: "enterprise",
  data() {
    return {
      optType:'edit',
      tableData: [],
      searchVal:"",
      content:"",
      options:[
        {
          label:"小程序",
          value:"0"
        },
        {
          label:"管理后台",
          value:"1"
        }
      ],
      dialogFormVisible:false,
      form:{
        type:"0",
        title:"",
        wxUrl:"",
        content:"",
        systemVersion:""
      },
      urlData:null,
    };
  },
  components: {
    ContentView
  },
  created() {
    this.urlData = this.$router.currentRoute.query;
    if(this.urlData.id){
        this.load();
    }
    if(this.urlData.type){
        this.optType=this.urlData.type
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    $("#summernote").summernote({
      lang: "zh-CN",
      placeholder: "请输入内容",
      height: 340,
      width: "100%",
      htmlMode: true,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["fontsize", ["fontsize"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph", "height"]],
        ["insert", ["link", "picture"]],
        ["mybutton", ["myVideo"]],
      ],
      fontSizes: ["8", "9", "10", "11", "12", "14", "18", "24", "36"],
      fontNames: [
        "Arial",
        "Arial Black",
        "Comic Sans MS",
        "Courier New",
        "Helvetica Neue",
        "Helvetica",
        "Impact",
        "Lucida Grande",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
      buttons: {
        myVideo: "",
      },
      callbacks: {
        onSubmit: function () {
          vm.richContent = $("#summernote").summernote("code");
        },
        onPaste: function (ne) {
          // var bufferText = (
          //   (ne.originalEvent || ne).clipboardData || window.clipboardData
          // ).getData("Text/plain");
          // ne.preventDefault ? ne.preventDefault() : (ne.returnValue = false);
       
          // setTimeout(function () {
          //   document.execCommand("insertText", false, bufferText);
          // }, 10);
        },
      },
    });
  },
  methods: {
    //---------------查询区域--------begin-----------
   
    load() {
      var that = this;
      var obj = {
        url: apiPub.GetSystemVersionId,
        data: {
          id: this.urlData.id
        }
      };
      $http.request(obj, false, function(res) {
        // console.log(res);
        if (res.code == 200) {
          that.form = res.data;
           $("#summernote").summernote("code", res.data.content);
          that.content = res.data.content;
        }
      });
    },
    // GetNoticeId
    //---------------业务区域--------end-----------
    onClose() {
      this.$router.back(-1);
    //   this.$router.push({ name: 'enterprise'});
    },
    onSave(){
      var that=this;
       var userinfo = JSON.parse(localStorage.getItem("userinfo"));
       var content = $("#summernote").summernote("code");
      // console.log(this.form)
      //  console.log(content)
      // return;
      var obj = {
        "url": apiPub.AddSystemVersion,
        "data":{
          Stype:this.form.type,
          CreatedUser:userinfo.id,
          WxUrl:this.form.wxUrl,
          "Content":content,
          "SystemVersion":this.form.systemVersion,
          "Title":this.form.title
        }
      };
      if(this.urlData.id){
          obj.url= apiPub.UpdateSystemVersion;
          obj.data.id= this.urlData.id;
      }
      $http.request(obj,false,function(res) {
        // console.log(res)
           that.$message({
                message: '保存成功',
                type: 'success'
            });
            that.onClose()
        // that.tableData=res.data;
      })
    },
    //---------------表格操作--------begin-----------
    
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.notice-form /deep/ .el-form-item__label{
    padding: 0;
    margin-bottom: 0;
  }
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
